import { AxiosError } from "axios";

import { getPartnerToken } from "./get-partner-token";
import { gupshupIntegrationService } from "@/api/customer-platform/whatsapp/gupshup-integration";
import { IGupshupAppDetails } from "@/interfaces/customer-platform.interfaces";

export async function checkGupshupAppStatus(appId: string): Promise<IGupshupAppDetails> {
  try {
    const partnerToken = await getPartnerToken();
    const details = await gupshupIntegrationService.getAppDetails(appId, partnerToken);

    return {
      appId: details.appId,
      appName: details.appName,
      status: details.status,
      phoneNumber: details.phoneNumber,
      phoneNumberId: details.phoneNumberId,
    };
  } catch (error) {
    if (error instanceof AxiosError) {
      
      if (error.response?.status === 401 || error.message === "UNAUTHORIZED") {
        const newPartnerToken = await getPartnerToken();
        const details = await gupshupIntegrationService.getAppDetails(appId, newPartnerToken);
        return {
          appId: details.appId,
          appName: details.appName,
          status: details.status,
          phoneNumber: details.phoneNumber,
          phoneNumberId: details.phoneNumberId,
        };
      }
      throw new Error(
        `Failed to check app status: ${error.response?.data?.message || error.message}`
      );
    }
    throw error;
  }
}
